import React from "react"
import { useNavigation } from "./context/NavigationContext"
import { NavigationStep } from "./models/NavigationStep"
import AssetTypeInput from "./components/InputForm/AssetTypeInput"
import ShipmentsInput from "./components/InputForm/ShipmentsInput"
import ExpenseInput from "./components/InputForm/ExpenseInput"
import ImprovementInput from "./components/InputForm/ImprovementInput"
import ResultsDisplay from "./components/ResultsDisplay/ResultsDisplay"
import Header from "./components/Shared/Header"
import Footer from "./components/Shared/Footer"
import { useCalculator } from "./context/CalculatorContext"
import styles from "./styles/Layout.module.css"

const App: React.FC = () => {
  const { currentStep, goToNextStep, goToPreviousStep, restart } =
    useNavigation()
  const { calculateResults } = useCalculator()

  const goToResults = () => {
    calculateResults()
    goToNextStep()
  }

  return (
    <div className={styles.appWrapper}>
      <Header />
      <main className={styles.mainContent}>
        {currentStep === NavigationStep.AssetType && (
          <AssetTypeInput onNext={goToNextStep} />
        )}
        {currentStep === NavigationStep.Shipments && (
          <ShipmentsInput onNext={goToNextStep} onBack={goToPreviousStep} />
        )}
        {currentStep === NavigationStep.BusinessExpense && (
          <ExpenseInput onNext={goToNextStep} onBack={goToPreviousStep} />
        )}
        {currentStep === NavigationStep.BusinessImprovement && (
          <ImprovementInput onNext={goToResults} onBack={goToPreviousStep} />
        )}
        {currentStep === NavigationStep.Results && (
          <ResultsDisplay onRestart={restart} onBack={goToPreviousStep} />
        )}
      </main>
      <Footer />
    </div>
  )
}

export default App
